import React,{useState,useRef,useEffect} from 'react'
import Navbar from '../components/Navbar.js'
import Footer from '../components/Footer.js'
import { Helmet } from 'react-helmet-async'

function Home() {
  const [standardContenious,setStandardContinuous] = useState(true)
  const [lexiContenious,setLexiContinuous] = useState(false)
  const [noncontenious,setNonContenious] = useState(false)
  const [merger,setMerger] = useState(false)
  const [name, setName] = useState('');
  const [firmName, setFirmName] = useState('');
  const [email,setEmail] = useState('');
  const [jurisdiction,setJurisdiction] = useState([]);
  const [practiceArea,setPracticeArea] = useState([]);
  const [toast, setToast] = useState({ message: '', type: '', visible: false })
  const [jurisdictionOpen, setJurisdictionOpen] = useState(false);
  const [practiceOpen, setPracticeOpen] = useState(false);
  const leadFormRef = useRef(null);
  const jurisdictionRef = useRef(null);
  const practiceRef = useRef(null);

  let updateview = (val) =>{
    if(val === "standardcont"){
        setStandardContinuous(true);
        setLexiContinuous(false);
        setMerger(false);
        setNonContenious(false);
    }
    else if(val === "lexicont"){
        setStandardContinuous(false);
        setLexiContinuous(true);
        setMerger(false);
        setNonContenious(false);
    }
    else if(val === "ma"){
        setStandardContinuous(false);
        setLexiContinuous(false);
        setMerger(true);
        setNonContenious(false);
    }
    else if(val === "noncont"){
        setStandardContinuous(false);
        setLexiContinuous(false);
        setMerger(false);
        setNonContenious(true);
    }
  }
  
  const showToast = (message, type) => {
      setToast({ message, type, visible: true })
      setTimeout(() => setToast({ message: '', type: '', visible: false }), 5000)
    }

  const logRequest = async () => {
      if(!name.trim()){
        showToast("Please enter your full name.", "error")
        return
      }
      if(!firmName.trim()){
        showToast("Please enter your firm name.", "error")
        return
      }
      if(!email.trim()){
        showToast("Please enter your work email address.", "error")
        return
      }
      if(jurisdiction.length === 0){
        showToast("Please select at least one jurisdiction.", "error")
        return
      }
      if(practiceArea.length === 0){
        showToast("Please select at least one practice area.", "error")
        return
      }

      try {
        const response = await fetch('https://cac3vl23dkklu4rdxwki5yooxa0upfuq.lambda-url.eu-west-2.on.aws/capture-lead', {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'name': name,
            'firm_name': firmName,
            'work_email': email,
            'primary_jurisdiction': jurisdiction,
            'primary_practice_area': practiceArea
          })
        });

        if(response.status === 422){
          showToast("Please provide a valid work email address. Personal email addresses — Gmail, Hotmail, Yahoo and similar — are not accepted.", "error")
        } else if(response.status === 409){
          showToast("This email address is already registered on the LexiTrove waitlist. We will be in touch ahead of the pilot cohort go-live.", "error")
        } else if(!response.ok){
          const error = await response.text()
          console.log(error)
          showToast("Your submission could not be processed. Please try again.", "error")
        } else {
          showToast("Expression of interest received. A member of the LexiTrove team will be in touch within 24 hours to schedule an initial consultation.", "success")
          setName('')
          setFirmName('')
          setEmail('')
          setJurisdiction([])
          setPracticeArea([])
          setJurisdictionOpen(false)
          setPracticeOpen(false)
        }
      } catch(err) {
        console.error("Network error:", err)
        showToast("A network error occurred. Please check your connection and try again.", "error")
      }
    }

  const scrollToForm = () => {
    leadFormRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if(jurisdictionRef.current && !jurisdictionRef.current.contains(e.target)){
        setJurisdictionOpen(false)
      }
      if(practiceRef.current && !practiceRef.current.contains(e.target)){
        setPracticeOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
   }, [])

  return (
    <div className='home'>
        <Helmet>
          <title>LexiTrove | Employment Law Intelligence Platform </title>
          <meta name='description' content='Privacy-first employment law intelligence for England & Wales, Scotland, and Northern Ireland practitioners. Built for solicitors, not general counsel'/>
          <link rel='canonical' href='https://www.lexitrove.com/'/>
          <meta property="og:site_name" content="LexiTrove" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="LexiTrove | Employment Law Intelligence Platform"/>
          <meta property="og:url" content='https://www.lexitrove.com/' />
          <meta property="og:description" content= "Privacy-first employment law intelligence for England & Wales, Scotland, and Northern Ireland practitioners. Built for solicitors, not general counsel"/>
        </Helmet>
        <Navbar/>
        <div className='section'>
        <div className='hero'>
          <h1>LexiTrove</h1>
          <span>Employment Law Intelligence Platform</span><br/><br/>
          <p>The compliance first intelligence platform engineered for UK employment practice. Built across all four jurisdictions England, Northern Ireland, Scotland and Wales and aligned with the Employment Rights Act 2025.<br/><br/> Designed to support the full matter lifecycle, from client intake to post tribunal judgment. Legal data processed entirely within the LexiTrove environment.</p>
          <br/><button className='cta-button' onClick={scrollToForm}>Join Founding Cohort</button>
        </div>
        <div className='waitlist'>
          <div className='hero-header'>
            <h5>Employment Law Intelligence Platform - Case Management Order</h5>
            <div id = "hero-header-text">
            <div>
            <span>Case Order:</span>  <span>LT-2026-01</span><br/>
            <span>Jurisdiction:</span>  <span>England, Northern Ireland,<br/>Scotland and Wales </span><br/>
            </div>
            <div>
            <span>Order Issued:</span>  <span>30-06-2026</span><br/>
            <span>Order Type:</span>  <span>Full Platform Direction</span><br/>
            </div>
            </div>
            <hr/>
            <h5>LexiTrove V. Employment Law Complexity</h5>
            <span>These directions are issued following the preliminary hearing and are binding on all parties.</span>
            <hr/>
            <h5>Directions & compliance schedule</h5>
            <hr/>
            <div className='Hero-Table'>
              <span>1.</span>
              <span>
                  <strong>Platform Establishment</strong>
                  <p>Company incorporated. Core jurisdictional logic and compliance frameworks successfully finalized across all four nations.</p>
              </span>
              <span>14-05-2026</span>
              <span><button>Completed</button></span>
              </div>
              <hr/>
              <div className='Hero-Table'>
                  <span>2.</span>
                  <span>
                      <strong>Charter Intake</strong>
                      <p>Priority waitlist registration opens to secure early-access platform allocation and join our co-design initiative.</p>
                  </span>
                  <span>30-06-2026</span>
                  <span><button>Active</button></span>
              </div>
              <hr/>
              <div className='Hero-Table'>
                  <span>3.</span>
                  <span>
                      <strong>Pilot Commencement</strong>
                      <p>Enterprise pilot deployment begins with select Founding Cohort Firms, offering early-adopter commercial rates.</p>
                  </span>
                  <span>10-11-2026</span>
                  <span><button>Scheduled</button></span>
              </div>
              <hr/>
              <div className='Hero-Table'>
                  <span>4.</span>
                  <span>
                      <strong>General Platform Release</strong>
                      <p>Full platform release and commercial availability across all UK jurisdictions.</p>
                  </span>
                  <span>12-01-2027</span>
                  <span><button>Scheduled</button></span>
              </div>
            <hr/><br/>
          </div>
        </div>
        </div>
        <div className='hero2'>
        <div className='section2'>
        <div className='button-holder'>
        <button className='workflow-button' onClick={()=>updateview("standardcont")}>Contentious</button><br/>
        <button className='workflow-button' onClick={()=>updateview("noncont")}>Non-Contentious</button><br/>
        <button className='workflow-button' onClick={()=>updateview("ma")}>Merger & Acquisition</button>
        </div><br/>
        {
            (standardContenious || lexiContenious) &&
            <div>
            <h4>Understand the workflow before you understand the product.</h4><br/>
            <p>Employment matters follow a structured legal process. The work behind each stage - claim identification, limitation assessment, conciliation, tribunal procedure, remedy calculation - remains fragmented across systems, documents and research tools.</p><br/>
            <p>The workflow opposite maps a contentious employment matter from client intake to post-judgment, jurisdiction-specific across England, Wales, Scotland and Northern Ireland.</p><br/>
            <p>Toggle between The Standard Flow and LexiTrove Assisted to see where the platform provides intelligent assistance - from automated intake and limitation calculation through to remedy modelling and post-judgment drafting - while practitioners retain complete control of legal strategy and professional judgement.</p><br/>
            </div>
        }
        {
            noncontenious &&
            <div>
            <p>Non-contentious employment work is rarely straightforward. Contracts, policies, and compliance frameworks span multiple jurisdictions - each with its own statutory requirements, procedural obligations, and legislative timeline</p><br/>
            <p>The advisory work behind a handbook review, a TUPE transfer, or an ERA 2025 compliance audit draws on legislation, case law, regulatory guidance, and jurisdiction-specific divergence simultaneously.</p><br/>
            <p>LexiTrove is building the Non-Contentious Advisory module with founding cohort input. If non-contentious employment work is a significant part of your practice, we'd like to hear from you.</p><br/>
            </div>
        }
        {
            merger &&
            <div>
            <p>Employment due diligence in an M&A transaction demands precision across multiple data sources, each carrying its own risk. Workforce liabilities, undisclosed claims, TUPE obligations, and golden parachute arrangements must be identified, verified, and accurately reflected in the Share Purchase Agreement.</p><br/>
            <p>The cost of missing an employment liability at due diligence is rarely abstract - it lands in the SPA, the price adjustment, or post-completion litigation.</p><br/>
            <p>LexiTrove is building the M&A Employment module with founding cohort input. If employment due diligence is part of your transaction practice, we'd like to hear from you.</p><br/>
            </div>
        }
        </div>
        <div className='flowchart'>
        {
            standardContenious &&
          <div>
          <button className='toggle-button' onClick={()=>updateview("standardcont")}>Standard Flow</button>
          <button className='toggle-button' onClick={()=>updateview("lexicont")}>LexiTrove Assisted</button><br/>
          <span>Client Intake</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Initial contact & entry point assessment</h5>
                <p>Client's position in the dispute is established. Whether the matter is at an internal resolution stage, early conciliation, tribunal proceedings or post-judgment determines the subsequent workflow.</p>
            </div>
            <div id="flowchart-text">
                <h5>Conflict check</h5>
                <p>Before any confidential information is received, the firm checks the respondent and connected parties against existing clients in accordance with SRA obligations.</p>
            </div>
            <div id="flowchart-text">
                <h5>Claim type identification</h5>
                <p>The client's narrative is analysed to identify all potential causes of action. A single factual background may give rise to multiple employment claims.</p>
            </div>
          </div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Limitation assessment</h5>
                <span id="label">ERA 2025</span>
                </div>
                <p>Limitation periods are determined by claim type and jurisdiction. Where applicable, extensions arising from ACAS Early Conciliation or LRA procedures are considered.</p>
            </div>
            <div id="flowchart-text">
                <h5>Preliminary merits assessment</h5>
                <p>An initial assessment determines whether the matter has a realistic prospect of success and identifies the principal factual and legal issues requiring further investigation.</p>
            </div>
            <div id="flowchart-text">
                <h5>Client onboarding</h5>
                <p>Following acceptance of instructions, engagement documentation is issued and regulatory obligations relating to costs and client care are satisfied before substantive work begins.</p>
            </div>
          </div>
          </div>
          <span>Entry Point Routing</span>
          <div id="flowchart-4-col">
            <div id="flowchart-text">
                <h5>Internal resolution</h5>
                <p>Client arrives during or immediately after internal grievance or disciplinary process. Matter has not yet reached ACAS or LRA.</p>
            </div>
            <div id="flowchart-text">
                <h5>Early conciliation</h5>
                <p>Internal process exhausted or bypassed. Client arrives at ACAS or LRA conciliation stage. ET1 not yet presented.</p>
            </div>
            <div id="flowchart-text">
                <h5>Tribunal proceedings</h5>
                <p>ET1 filed or about to be filed. Client arrives mid-proceedings or at point of claim presentation.</p>
            </div>
            <div id="flowchart-text">
                <h5>Post Judgment</h5>
                <p>Client arrives after judgment. Reconsideration, EAT appeal, enforcement, or costs application.</p>
            </div>
          </div>
          <span>Internal Resolution</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Grievance & disciplinary advisory</h5>
                <span id="label">ERA 2025</span>
                </div>
                <p>ACAS Code of Practice compliance assessed against steps taken.Employers must follow a fair procedure from the outset. Uplift or reduction of up to 25% applied where either party unreasonably fails to follow the Code s.207A TULRCA 1992.NI Article 90AA of the Industrial Relations Order 1992 applies.</p>
            </div>
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Fire and rehire risk</h5>
                <span id="label">ERA 2025</span>
                </div>
                <p>ERA 2025 restricts fire and rehire. Prescribed consultation process required before dismissal for non-acceptance of new terms. Failure  automatic unfair dismissal. Advise employer on prescribed process compliance.</p>
            </div>
            <div id="flowchart-text">
                <h5>Settlement prospects assessment</h5>
                <p>Without prejudice discussions advised where appropriate. Settlement Agreement  s.203 ERA 1996 requirements. NI: Article 245 ERO 1996. Independent legal advice obligation confirmed.</p>
            </div>
          </div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Internal resolution achieved?</h5>
                <p>Matter resolves before ACAS or LRA involvement.</p>
            </div>
            <div id="flowchart-text">
                <h5>Settlement Agreement</h5>
                <p>E&W & Scotland: s.203 ERA 1996  independent legal advice required. NI: Article 245 ERO 1996. Matter closed.</p>
            </div>
            <div id="flowchart-text">
                <h5>Proceed to early conciliation</h5>
                <p>Mandatory pre-claim step. Matter routes to Phase 3.</p>
            </div>
          </div>
          </div>
          <span> Early conciliation</span>
          <div>
          <div id="flowchart-2-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>ACAS early conciliation</h5>
                <span id="label">ERA 2025</span>
                </div>
                <p>Notification to ACAS. EC period up to 6 weeks. Limitation clock stops as per Section 207B ERA 1996 & s.140B EA 2010. Certificate issued on conclusion  required to file ET1.</p>
            </div>
            <div id="flowchart-text">
                <h5>Labour Relations Agency</h5>
                <p>Notification to the LRA. Conciliation period up to one month extendable by 14 days. CO3 issued on conclusion where settlement reached. Early conciliation certificate issued where no settlement - required to present tribunal claim.</p>
            </div>
          </div>
          <div id="flowchart-4-col">
            <div id="flowchart-text">
                <h5>Settled at conciliation?</h5>
                <p>Settlement reached through conciliation body.</p>
            </div>
            <div id="flowchart-text">
                <h5>COT3  E&W & Scotland</h5>
                <p>ACAS conciliated settlement. Statutory rights validly compromised. Enforceable as court order.</p>
            </div>
            <div id="flowchart-text">
                <h5>LRA conciliated settlement  NI</h5>
                <p>Reached through LRA conciliation CO3 issued. Matter closed.</p>
            </div>
            <div id="flowchart-text">
                <h5>ET1 presentation</h5>
                <p>E&W & Scotland: ET1 via MyHMCTS. NI: ET1 (NI) submitted via OITFET portal. </p>
            </div>
          </div>
          </div>
          <span>Tribunal proceedings</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>ET1 accepted  ET3 response</h5>
                <p>Respondent: 28 days to present ET3. Default judgment on non-response. Sift by Employment Judge.ET Procedure Rules 2024 (SI 2024/1155).</p>
            </div>
            <div id="flowchart-text">
                <h5>ET Edinburgh or Glasgow</h5>
                <p>Same ET Rules 2013. Separate tribunal administration. ET Edinburgh and Glasgow only.</p>
            </div>
            <div id="flowchart-text">
                <h5>ET1 accepted  ET3 response - NI</h5>
                <p>ET1 (NI) accepted by OITFET. Respondent has 28 days to present ET3 response.Industrial Tribunal handles standard workplace disputes.Fair Employment Tribunal handles religious belief and political opinion discrimination specifically.</p>
            </div>
          </div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Preliminary hearing preparation</h5>
                <p>Case management directions prepared and list of issues agreed ahead of hearing. Preliminary issues identified - jurisdiction, employment status, limitation, strike out risk under rule 40 and deposit order exposure under rule 40 of the Employment Tribunal Procedure Rules 2024 (SI 2024/1155).</p>
            </div>
            <div id="flowchart-text">
                <h5>Preliminary hearing</h5>
                <p>E&W & Scotland: Case management directions issued. Strike out - r.38. Deposit order up to £1,000 - r.40. Employment Tribunal Procedure Rules 2024 (SI 2024/1155).Northern Ireland: Case management directions issued. Strike out - r.32. Deposit order up to £500 - r.34. IT & FET Rules (NI) 2020 as amended S.R. 2024/197.</p>
            </div>
            <div id="flowchart-text">
                <h5>Strike out or deposit ordered?</h5>
                <p>E&W & Scotland: No reasonable prospects - r.38 ET Procedure Rules 2024 (SI 2024/1155). Deposit up to £1,000 - r.40. Costs at r.73 if deposit forfeited.
Northern Ireland: No reasonable prospects - r.32. Deposit up to £500 - r.34. Costs at r.73 IT & FET Rules (NI) 2020.</p>
            </div>
          </div>
          <div id="flowchart-2-col">
            <div id="flowchart-text">
                <h5>Disclosure & evidence</h5>
                <p>Standard disclosure. Witness statements exchanged simultaneously. Agreed bundle prepared. DSAR strategy where relevant.</p>
            </div>
            <div id="flowchart-text">
                <h5>Full merits hearing</h5>
                <p>E&W & Scotland: Panel or Employment Judge alone. Oral evidence and submissions. Reserved or ex tempore judgment.Northern Ireland: Industrial Tribunal or Fair Employment Tribunal. Panel or Employment Judge alone.</p>
            </div>
          </div>
          </div>
          <span>Judgment & remedy</span>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Liability determined</h5>
                <p>Judgment on liability. Remedy hearing listed separately or dealt with at same hearing.</p>
            </div>
            <div id="flowchart-text">
                <h5>Claim dismissed</h5>
                <p>E&W & Scotland: Costs application open - r.73 ET Procedure Rules 2024 (SI 2024/1155). Wasted costs where representative conduct in issue.
Northern Ireland: Costs application open - r.73 IT & FET Rules (NI) 2020. Wasted costs where representative conduct in issue.</p>
            </div>
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Remedy hearing</h5>
                <span id="label">ERA 2025</span>
                </div>
                <p>E&W & Scotland: Basic award + compensatory award - cap £123,543 or 52 weeks' gross pay. ERA 2025 removes cap from 1 January 2027. Discrimination uncapped. Polkey & contributory fault applied. Vento bands updated 6 April 2026.Northern Ireland: Equivalent remedy provisions under ERO 1996 - separate NI compensation limits apply</p>
            </div>
          </div>
          <span>Post Judgment</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Reconsideration</h5>
                <p>E&W & Scotland: Application within 14 days of written judgment. Interests of justice only - r.68 ET Procedure Rules 2024 (SI 2024/1155). Refused without hearing if no reasonable prospect of original decision being varied or revoked.</p>
            </div>
            <div id="flowchart-text">
                <h5>Employment Appeal Tribunal</h5>
                <p>E&W & Scotland: Error of law only - s.21 ETA 1996. 42 days from written reasons. EAT London - E&W. EAT Edinburgh - Scotland.Northern Ireland: No EAT jurisdiction. Appeals on point of law go directly to the Court of Appeal Belfast. Six weeks from date of written decision.</p>
            </div>
            <div id="flowchart-text">
                <h5>Enforcement</h5>
                <p>E&W & Scotland: County Court warrant of control. 50% penalty on unpaid award - s.37A–37H ETA 1996. Administered by the Fair Work Agency. Penalty cap £20,000. Employer naming scheme operates in parallel.</p>
            </div>
          </div>
          <div id="flowchart-4-col-last">
            <div id="flowchart-text">
                <h5>Court of Appeal</h5>
                <p>Further appeal on point of law. Permission required.</p>
            </div>
            <div id="flowchart-text">
                <h5>Court of Session</h5>
                <p>Scottish appellate court above EAT Edinburgh. Permission required. Distinct from Court of Appeal.</p>
            </div>
            <div id="flowchart-text">
                <h5>Court of Appeal Belfast</h5>
                <p>NI appellate jurisdiction. Permission required. Separate from GB appeal routes.</p>
            </div>
            <div id="flowchart-text">
                <h5>Supreme Court</h5>
                <p>Final appellate jurisdiction across all UK nations. Permission required. Binding precedent.</p>
            </div>
          </div>
          </div>
          </div>
        }
        {
            lexiContenious &&
        <div>
          <button className='toggle-button' onClick={()=>updateview("standardcont")}>Standard Flow</button>
          <button className='toggle-button' onClick={()=>updateview("lexicont")}>LexiTrove Assisted</button><br/>
          <span>Client Intake</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Initial contact & entry point assessment</h5>
                <ul>
                    <li>Employment specific intake forms embedded on the firm's website matters opened automatically</li>
                    <li>Voice agent answers telephone enquiries transcribed and attached to matter</li>
                    <li>Intake emails analysed on arrival LexiTrove follows up where key information is missing</li>
                    <li>All enquiries consolidated into a single matter record in the LexiTrove workspace</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Conflict check</h5>
                <ul>
                <li>Respondent employer and connected parties checked automatically against firm's client database</li>
                <li>Conflict flagged before any confidential matter information is received</li>
                <li>SRA Code of Conduct obligations surfaced where conflict identified</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Claim type identification</h5>
                <ul>
                <li>Claim type identified from intake data - unfair dismissal, discrimination, whistleblowing, redundancy, breach of contract</li>
                <li>Multiple potential claims surfaced simultaneously from single fact pattern</li>
                <li>NI jurisdiction flagged automatically where client or employer is NI-based</li>
                </ul>
            </div>
          </div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Limitation assessment</h5>
                <span id="label">ERA 2025</span>
                </div>
                <ul>
                <li>Statute of limitations run automatically against claim type and jurisdiction</li>
                <li>207B ERA 1996 & s.140B EA 2010 extension calculated where ACAS EC period identified in intake data</li>
                <li>NI: Article 90AA of the Industrial Relations Order 1992 applies</li>
                <li>Risk flagged immediately where limitation is imminent or expired</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Preliminary merits assessment</h5>
                <ul>
                <li>Claimant's inputs validated for clarity, consistency, and evidential gaps</li>
                <li>Respondent's tribunal history fetched - prior claims, outcomes, and patterns surfaced</li>
                <li>Initial fact set analysed for strike out risk - no reasonable prospects threshold assessed against r.38 Employment Tribunal Procedure Rules 2024 (SI 2024/1155). NI: r.32 IT & FET Rules (NI) 2020.</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Client onboarding</h5>
                <ul>
                <li>Engagement letter drafted automatically from intake data</li>
                <li>Client care letter generated - SRA Transparency Rules compliant</li>
                <li>Terms of business populated - ready for review and issue</li>
                </ul>
            </div>
          </div>
          </div>
          <span>Internal Resolution</span>
          <div>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Grievance & disciplinary advisory</h5>
                <span id="label">ERA 2025</span>
                </div>
                <ul>
                <li>ACAS Code compliance checked against steps taken - specific procedural gaps identified</li>
                <li>Uplift and reduction exposure calculated by gap type - tribunal adjustment range surfaced</li>
                <li>Specific procedural failure matched against ET judgments at Level 3 - most relevant decisions and adjustment percentages applied surfaced. NI: Industrial Tribunal decisions surfaced separately</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Fire and rehire risk</h5>
                <span id="label">ERA 2025</span>
                </div>
                <ul>
                <li>ERA 2025 prescribed consultation process checked - compliance gaps identified before dismissal notices issued</li>
                <li>Automatic unfair dismissal exposure calculated where prescribed process not followed</li>
                <li>Comparable tribunal findings where fire and rehire led to liability surfaced by fact pattern</li>
                <li>NI: ERA 2025 inapplicability flagged automatically - pre-ERA position confirmed for NI matters</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Settlement prospects assessment</h5>
                <ul>
                <li>Without prejudice correspondence and Settlement Agreement drafted - s.203 ERA 1996 confirmed. NI: Article 245 ERO 1996</li>
                <li>PENP calculated automatically - correct tax treatment confirmed before agreement finalised</li>
                <li>Contractual vs compensation payment distinction flagged - £30,000 tax-free threshold applied</li>
                </ul>
            </div>
          </div>
          </div>
          <span> Early conciliation</span>
          <div>
          <div id="flowchart-2-col">
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>ACAS early conciliation</h5>
                <span id="label">ERA 2025</span>
                </div>
                <ul>
                <li>Extended deadline recalculated once EC certificate dates confirmed</li>
                <li>LexiTrove drafts COT3 - clause library populated, jurisdiction-specific requirements confirmed</li>
                <li>Tribunal outcome benchmarking surfaced - comparable outcomes by claim type and fact pattern, likely deductions calculated - Polkey, contributory fault, ACAS Code adjustment</li>
                <li>Realistic net recovery range surfaced to inform COT3 offer evaluation against tribunal risk</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Labour Relations Agency</h5>
                <ul>
                <li>NI: Article 90AA of the Industrial Relations Order 1992 applies</li>
                <li>CO3 drafted on settlement - LRA's conciliation instrument</li>
                <li>Tribunal benchmarking surfaced against Industrial Tribunal and Fair Employment Tribunal outcomes - NI decisions surfaced separately</li>
                </ul>
            </div>
          </div>
          </div>
          <span>Tribunal proceedings</span>
          <div>
          <div id="flowchart-2-col">
            <div id="flowchart-text">
                <h5>ET1 accepted  ET3 response</h5>
                <ul>
                <li>ET1 grounds of claim drafted - correct statutory basis for each head of claim confirmed by jurisdiction</li>
                <li>ET3 grounds of resistance drafted - respondent's defence structured by claim type and jurisdiction</li>
                <li>ET3 analysed on receipt - respondent's grounds of resistance identified, new matters raised flagged, weaknesses in the response surfaced</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Preliminary hearing preparation</h5>
                <ul>
                <li>Directions commonly sought by claim type flagged - specific disclosure, unless orders, Scott Schedule where multiple complaints</li>
                <li>Strike out and deposit order exposure assessed at intake - findings carried forward</li>
                <li>Applications prepared on the basis of ET3 analysis</li>
                </ul>
            </div>
          </div>
          <div id="flowchart-2-col">
            <div id="flowchart-text">
                <h5>Disclosure & evidence</h5>
                <ul>
                <li>Specific disclosure obligations surfaced by claim type</li>
                <li>DSAR strategy surfaced - LPP exemption, management information exemption, third party redaction, deadline management</li>
                <li>Bundle preparation supported - document organisation and indexing guidance</li>
                <li>Witness statements drafted - jurisdiction-specific requirements confirmed</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Full merits hearing</h5>
                <ul>
                <li>Comparable outcomes surfaced by claim type, fact pattern and jurisdiction</li>
                <li>Relevant case law surfaced by issue - updated on legislative change</li>
                <li>Skeleton argument and written submissions drafted</li>
                <li>Scotland: ET Edinburgh and Glasgow practice notes surfaced. NI: Industrial Tribunal and Fair Employment Tribunal practice directions surfaced separately by claim type</li>
                </ul>
            </div>
          </div>
          </div>
          <span>Judgment & remedy</span>
          <div id="flowchart-3-col">
            <div id="flowchart-text">
                <h5>Liability determined</h5>
                <ul>
                <li>Judgment analysed on receipt - grounds for appeal, reconsideration, or enforcement identified</li>
                <li>Error of law identified - EAT appeal viability flagged</li>
                <li>Post-judgment applications drafted - reconsideration under r.68-71 Employment Tribunal Procedure Rules 2024 (SI 2024/1155). NI: equivalent reconsideration provisions under IT & FET Rules (NI) 2020</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Claim dismissed</h5>
                <ul>
                <li>r.73 costs threshold case law surfaced - unreasonable conduct test applied. ET Procedure Rules 2024 (SI 2024/1155). NI: r.73 IT & FET Rules (NI) 2020</li>
                <li>Wasted costs precedents surfaced where representative conduct in issue</li>
                <li>Schedule of costs drafted - ready for submission</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <div id = "label-wrap">
                <h5>Remedy hearing</h5>
                <span id="label">ERA 2025</span>
                </div>
                <ul>
                <li>Basic award calculated automatically - age, service, and weekly pay applied</li>
                <li>Compensatory award calculated - cap £123,543 or 52 weeks' gross pay whichever is lower. ERA 2025 removes cap from 1 January 2027</li>
                <li>Polkey reduction and contributory fault scenarios modelled</li>
                <li>Vento bands applied for injury to feelings - lower £1,300–£12,600, middle £12,600–£37,700, upper £37,700–£62,900. Updated 6 April 2026</li>
                <li>PENP calculated where relevant - correct tax treatment confirmed</li>
                <li>Schedule of loss drafted - all heads of remedy populated automatically</li>
                </ul>
            </div>
          </div>
          <span>Post Judgment</span>
          <div>
          <div id="flowchart-3-col-last">
            <div id="flowchart-text">
                <h5>Reconsideration</h5>
                <ul>
                <li>Grounds for reconsideration identified - interests of justice or clerical error under r.68-71</li>
                <li>Reconsideration application drafted - ready for submission within 14-day deadline</li>
                <li>14-day deadline tracked from date of written judgment - alert surfaced before expiry</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Employment Appeal Tribunal</h5>
                <ul>
                <li>Error of law grounds identified against s.21 ETA 1996 - EAT appeal viability assessed</li>
                <li>Appeal notice drafted - ready for submission within 42-day deadline</li>
                <li>42-day deadline tracked from written reasons - alert surfaced before expiry</li>
                <li>EAT practice directions surfaced - EAT London E&W, EAT Edinburgh Scotland, Court of Appeal Belfast NI</li>
                </ul>
            </div>
            <div id="flowchart-text">
                <h5>Enforcement</h5>
                <ul>
                <li>County Court warrant of control process guided - E&W & Scotland. Fair Work Agency penalty scheme surfaced - 50% penalty on unpaid award, cap £20,000. s.37A–37H ETA 1996</li>
                <li>NI enforcement process surfaced separately and automatically when NI jurisdiction detected</li>
                </ul>
            </div>
          </div>
          </div>
          </div>
        }
        {
            noncontenious &&
            <div className='bolier-text'>
            <h3>Non-Contentious Advisory - Being developed with founding cohort input</h3><br/>
            <p>This module is being shaped with founding cohort input. Help determine what gets built for non-contentious employment practice.</p><br/>
            <button className='bolier-button' onClick={scrollToForm}>Join Founding Cohort</button>
            </div>
        }
         {
            merger &&
            <div className='bolier-text'>
            <h3>M&A Employment - Being developed with founding cohort input</h3><br/>
            <p>The M&A Employment module is being scoped with founding cohort members. Help shape what gets built for employment due diligence and transaction practice.</p><br/>
            <button className='bolier-button' onClick={scrollToForm}>Join Founding Cohort</button>
            </div>
        }
        </div>
        </div>
        <div className='section'>
        <div className='hero'>
          <p>LexiTrove is being built with employment law practitioners, not just for them.</p><br/>
          <p>By joining the Founding Cohort, you are securing more than early commercial access you are taking a seat at the table. Your firm's specific practice areas, multi-jurisdictional needs, and daily workflow bottlenecks will directly shape LexiTrove’s development roadmap.</p><br/>
          <p>Once submitted, our team will schedule a brief initial consultation to understand your firm’s specific requirements, confirm your pilot allocation, and lock in your founding member rates ahead of general release.</p><br/>
        </div>
        <div className='Lead-Form' ref={leadFormRef}>
          <form>
            <label>Name</label><br/>
            <input 
              type='text' 
              value={name} 
              onChange={(e) => setName(e.target.value)}
            /><br/>

            <label>Firm Name</label><br/>
            <input 
              type='text' 
              value={firmName} 
              onChange={(e) => setFirmName(e.target.value)}
            /><br/>

            <label>Work Email</label><br/>
            <input 
              type='text' 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}
            /><br/>

            <label>Primary Jurisdiction</label><br/>
            <div className='dropdown-wrapper' ref={jurisdictionRef}>
              <div 
                className='dropdown-trigger'
                onClick={(e) => {
                  e.stopPropagation()
                  setJurisdictionOpen(!jurisdictionOpen)
                }}
              >
                {jurisdiction.length > 0 ? jurisdiction.join(', ') : 'Select jurisdiction'}
              </div>
              {jurisdictionOpen && (
                <div className='dropdown-options'>
                  {['England', 'Wales', 'Scotland', 'Northern Ireland'].map(option => (
                    <div 
                      key={option} 
                      className='checkbox-row'
                      onClick={(e) => {
                        e.stopPropagation()
                        if(jurisdiction.includes(option)){
                          setJurisdiction(jurisdiction.filter(j => j !== option))
                        } else {
                          setJurisdiction([...jurisdiction, option])
                        }
                      }}
                    >
                      <input 
                        type='checkbox'
                        checked={jurisdiction.includes(option)}
                        onChange={() => {}}
                        readOnly
                      />
                      <span>{option}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          
            <label>Primary Practice Area</label><br/>
            <div className='dropdown-wrapper' ref={practiceRef}>
              <div 
                className='dropdown-trigger'
                onClick={(e) => {
                  e.stopPropagation()
                  setPracticeOpen(!practiceOpen)
                }}
              >
                {practiceArea.length > 0 ? practiceArea.join(', ') : 'Select practice area'}
              </div>
              {practiceOpen && (
                <div className='dropdown-options'>
                  {['Contentious', 'Non-Contentious', 'Merger & Acquisition'].map(option => (
                    <div 
                      key={option} 
                      className='checkbox-row'
                      onClick={(e) => {
                        e.stopPropagation()
                        if(practiceArea.includes(option)){
                          setPracticeArea(practiceArea.filter(p => p !== option))
                        } else {
                          setPracticeArea([...practiceArea, option])
                        }
                      }}
                    >
                      <input 
                        type='checkbox'
                        checked={practiceArea.includes(option)}
                        onChange={() => {}}
                        readOnly
                      />
                      <span>{option}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          
            <button 
              type="button" 
              onClick={() => logRequest()}
              className='cta-button'
            >
              Join Founding Cohort
            </button>
          </form>
        </div>
        </div>
        {toast.visible && (
          <>
            {/* Overlay */}
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 999
            }}/>

            {/* Modal */}
            <div style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#F4F1EA',
              border: `1px solid ${toast.type === 'success' ? '#C96A4A' : '#1A1A1A'}`,
              borderTop: `3px solid ${toast.type === 'success' ? '#C96A4A' : '#1A1A1A'}`,
              padding: '2rem',
              fontFamily: "'Jost', monospace",
              fontSize: '0.75rem',
              color: toast.type === 'success' ? '#C96A4A' : '#1A1A1A',
              maxWidth: '400px',
              width: '90%',
              zIndex: 1000,
              lineHeight: '1.8',
              textAlign: 'center'
            }}>
              <p style={{marginBottom: '1.5rem'}}>{toast.message}</p>
              <button 
                onClick={() => setToast({ message: '', type: '', visible: false })}
                style={{
                  fontFamily: "'Jost', monospace",
                  fontSize: '0.75rem',
                  backgroundColor: toast.type === 'success' ? '#C96A4A' : '#1A1A1A',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 20px',
                  cursor: 'pointer',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase'
                }}
              >
                Close
              </button>
            </div>
          </>
        )}
        <Footer/> 
    </div>
  )
}

export default Home